import React from 'react';

import { BRIDGE_PATH } from 'constants/routes';

import {
  Product,
  ProductBody,
  ProductHeader,
  ProductList,
  ProductThumb,
  IconDiv,
} from '../styles';
import { HomePageButtonNew } from 'components/temoraryHomePage';
import thumb from './thumb.jpeg';
import { Icon } from 'components/shared';

function FixNFlip() {
  const advantages = [
    '12-Month Interest Only (with no prepayment penalty)',
    'Up to 90% of Purchase Price & 100% of Repairs',
    'Up to 75% ARV ',
    'No Interest on Unused Rehab Funds',
  ];

  return (
    <Product color="bridge" to={BRIDGE_PATH}>
      <div>
        <div>
          <ProductHeader>
            <IconDiv>
              <Icon icon='home' />
            </IconDiv>
            Fix-n-Flip Loans
          </ProductHeader>
          <ProductThumb src={thumb} />
        </div>
        <ProductBody>
          <ProductList>{advantages}</ProductList>
        </ProductBody>
      </div>
      <HomePageButtonNew>Apply now</HomePageButtonNew>
    </Product>
  );
}

export default FixNFlip;
